(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cybersight-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-before-after')) {
    customElements.define(
      'cs-before-after',
      class extends HTMLElement {
        connectedCallback() {
          queueMicrotask(() => {
            if (this.isConnected && !this.controller) this.setup();
          });
        }
        setup() {
          this.controller = new AbortController();
          const { signal } = this.controller;
          this.track = this.querySelector('.cs-ba__track');
          this.cards = Array.from(this.querySelectorAll('.cs-ba__card'));
          this.navigation = this.querySelector('.cs-ba__navigation');
          this.carousel = this.querySelector('.cs-ba__carousel');
          this.comparison = this.querySelector('.cs-ba__comparison');
          this.status = this.querySelector('[data-cs-ba-status]');
          this.rtl = getComputedStyle(this.track).direction === 'rtl';
          this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
          this.addEventListener('pointerdown', (event) => this.startDrag(event), { signal });
          this.addEventListener('pointermove', (event) => this.moveDrag(event), { signal });
          this.addEventListener('pointerup', (event) => this.endDrag(event), { signal });
          this.addEventListener('pointercancel', (event) => this.endDrag(event), { signal });
          this.addEventListener('lostpointercapture', (event) => this.endDrag(event), { signal });
          this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
          this.addEventListener(
            'click',
            (event) => {
              const arrow = event.target.closest('[data-step]');
              if (arrow) this.goTo(this.nearestIndex() + Number(arrow.dataset.step));
            },
            { signal },
          );
          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const card = event.target.closest('.cs-ba__card');
              if (card) this.goTo(this.cards.indexOf(card), false);
            },
            { signal },
          );
          this.track.addEventListener('scroll', () => this.scheduleUpdate(), { signal, passive: true });
          this.observer = new ResizeObserver(() => this.scheduleUpdate());
          this.observer.observe(this.track);
          if (this.comparison) this.observer.observe(this.comparison);
          this.updateNavigation();
        }
        disconnectedCallback() {
          this.controller?.abort();
          this.observer?.disconnect();
          cancelAnimationFrame(this.frame);
          this.track?.classList.remove('is-dragging');
          this.drag = null;
          this.controller = null;
        }
        scheduleUpdate() {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateNavigation());
        }
        nearestIndex() {
          const track = this.track.getBoundingClientRect();
          let nearest = 0,
            distance = Infinity;
          this.cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const delta = Math.abs(this.rtl ? rect.right - track.right : rect.left - track.left);
            if (delta < distance) {
              distance = delta;
              nearest = index;
            }
          });
          return nearest;
        }
        goTo(index, animate = true) {
          const card = this.cards[Math.max(0, Math.min(this.cards.length - 1, index))];
          if (!card) return;
          const track = this.track.getBoundingClientRect();
          const rect = card.getBoundingClientRect();
          this.track.scrollBy({
            left: this.rtl ? rect.right - track.right : rect.left - track.left,
            behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant',
          });
        }
        updateNavigation() {
          if (!this.navigation) return;
          const columns = Number(getComputedStyle(this.carousel).getPropertyValue('--cs-ba-visible-columns')) || 1;
          const hasNavigation = this.cards.length > columns;
          this.carousel.classList.toggle('has-navigation', hasNavigation);
          if (hasNavigation && this.comparison) {
            this.carousel.style.setProperty(
              '--cs-ba-navigation-top',
              this.comparison.getBoundingClientRect().height / 2 + 'px',
            );
          }
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.navigation.hidden = !hasNavigation || max <= 2;
          this.navigation.querySelector('[data-step="-1"]').disabled = position <= 2;
          this.navigation.querySelector('[data-step="1"]').disabled = position >= max - 2;
          const value = this.nearestIndex() + 1 + ' / ' + this.cards.length;
          if (this.status.textContent !== value) this.status.textContent = value;
        }
        setPosition(handle, value) {
          value = Math.round(Math.max(0, Math.min(100, value)));
          const comparison = handle.closest('.cs-ba__comparison');
          comparison.style.setProperty('--cs-ba-position', value + '%');
          handle.setAttribute('aria-valuenow', value);
          handle.setAttribute(
            'aria-valuetext',
            comparison.dataset.before + ' ' + value + '%, ' + comparison.dataset.after + ' ' + (100 - value) + '%',
          );
        }
        startDrag(event) {
          if (!event.isPrimary || event.button !== 0 || this.drag) return;
          const handle = event.target.closest('.cs-ba__handle');
          if (handle) {
            event.preventDefault();
            event.stopPropagation();
            handle.focus({ preventScroll: true });
            this.drag = {
              type: 'compare',
              pointer: event.pointerId,
              handle,
              x: event.clientX,
              value: Number(handle.getAttribute('aria-valuenow')),
              width: handle.parentElement.getBoundingClientRect().width,
            };
            handle.setPointerCapture(event.pointerId);
          } else if (
            event.pointerType === 'mouse' &&
            this.track.contains(event.target) &&
            !event.target.closest('a, button, input, select, textarea')
          ) {
            event.preventDefault();
            this.drag = { type: 'carousel', pointer: event.pointerId, x: event.clientX, scroll: this.track.scrollLeft };
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture(event.pointerId);
          }
        }
        moveDrag(event) {
          if (!this.drag || event.pointerId !== this.drag.pointer) return;
          if (this.drag.type === 'compare') {
            event.preventDefault();
            this.setPosition(
              this.drag.handle,
              this.drag.value + ((event.clientX - this.drag.x) / Math.max(1, this.drag.width)) * 100,
            );
          } else {
            this.track.scrollLeft = this.drag.scroll - (event.clientX - this.drag.x);
          }
        }
        endDrag(event) {
          if (!this.drag || event.pointerId !== this.drag.pointer) return;
          const drag = this.drag;
          this.drag = null;
          const target = drag.type === 'compare' ? drag.handle : this.track;
          if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
          if (drag.type === 'carousel') {
            const index = this.nearestIndex();
            this.track.classList.remove('is-dragging');
            this.goTo(index);
          }
        }
        onKeydown(event) {
          const handle = event.target.closest('.cs-ba__handle');
          if (handle) {
            const value = Number(handle.getAttribute('aria-valuenow'));
            const values = {
              ArrowLeft: value - 1,
              ArrowRight: value + 1,
              ArrowDown: value - 1,
              ArrowUp: value + 1,
              PageDown: value - 10,
              PageUp: value + 10,
              Home: 0,
              End: 100,
            };
            if (event.key in values) {
              event.preventDefault();
              event.stopPropagation();
              this.setPosition(handle, values[event.key]);
            }
          } else if (event.target === this.track) {
            const step = this.rtl ? -1 : 1;
            const indices = {
              ArrowLeft: this.nearestIndex() - step,
              ArrowRight: this.nearestIndex() + step,
              Home: 0,
              End: this.cards.length - 1,
            };
            if (event.key in indices) {
              event.preventDefault();
              this.goTo(indices[event.key]);
            }
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-gallery-navigation')) {
    customElements.define(
      'cs-gallery-navigation',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();
          this.setupFrame = requestAnimationFrame(() => this.setupCarousel());
        }

        setupCarousel() {
          this.carousel = this.querySelector('scroll-carousel');
          this.sectionStack = this.querySelector('.section-stack');
          this.previousButtons = Array.from(this.querySelectorAll('carousel-prev-button button'));
          this.nextButtons = Array.from(this.querySelectorAll('carousel-next-button button'));

          if (!this.carousel || !this.sectionStack) {
            return;
          }

          this.carousel.addEventListener('pointerdown', (event) => this.onPointerDown(event), {
            signal: this.abortController.signal,
          });
          window.addEventListener('pointerup', (event) => this.onPointerUp(event), {
            signal: this.abortController.signal,
          });
          window.addEventListener('pointercancel', () => (this.pointerStart = null), {
            signal: this.abortController.signal,
          });
          this.carousel.addEventListener('carousel:select', (event) => this.updateArrowCenter(event.detail.cell), {
            signal: this.abortController.signal,
          });
          this.carousel.addEventListener('scroll', () => this.scheduleNavigationStateUpdate(), {
            passive: true,
            signal: this.abortController.signal,
          });
          ['carousel:change', 'carousel:settle', 'scroll:edge-nearing', 'scroll:edge-leaving'].forEach((eventName) => {
            this.carousel.addEventListener(eventName, () => this.scheduleNavigationStateUpdate(), {
              signal: this.abortController.signal,
            });
          });
          this.querySelectorAll('carousel-prev-button, carousel-next-button').forEach((control) => {
            const direction = control.localName === 'carousel-prev-button' ? 'start' : 'end';

            control.addEventListener('click', (event) => this.onDirectionClick(event, direction), {
              capture: true,
              signal: this.abortController.signal,
            });
          });

          this.resizeObserver = new ResizeObserver(() => {
            this.scheduleNavigationStateUpdate();
            this.updateArrowCenter();
          });
          this.resizeObserver.observe(this.carousel);

          if (this.classList.contains('cs-gallery--center-arrows')) {
            const desktopArrows = this.querySelector('.cs-gallery__desktop-arrows');
            if (desktopArrows && this.classList.contains('cs-gallery--center-arrows-desktop')) {
              this.resizeObserver.observe(desktopArrows);
            }
            this.resizeObserver.observe(this.sectionStack);
            this.carousel.cells.forEach((slide) => {
              const media = slide.querySelector('.cs-gallery-slide__media');

              if (media) {
                this.resizeObserver.observe(media);
              }
            });
            this.updateArrowCenter();
          }

          this.scheduleNavigationStateUpdate();
        }

        onDirectionClick(event, direction) {
          const { atStart, atEnd } = this.getNavigationState();
          const isBlocked = direction === 'start' ? atStart : atEnd;

          if (!isBlocked) {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          this.updateNavigationState();
        }

        onPointerDown(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.isInteractive(event.target)) {
            this.pointerStart = null;
            return;
          }

          this.pointerStart = {
            x: event.clientX,
            y: event.clientY,
            index: this.carousel.selectedIndex,
          };
        }

        onPointerUp(event) {
          if (!this.pointerStart || event.pointerType !== 'mouse' || this.isInteractive(event.target)) {
            this.pointerStart = null;
            return;
          }

          const start = this.pointerStart;
          const deltaX = event.clientX - start.x;
          const deltaY = event.clientY - start.y;
          const isHorizontalDrag = Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY);
          let targetIndex = start.index;

          this.pointerStart = null;

          if (isHorizontalDrag) {
            const physicalDirection = deltaX < 0 ? 1 : -1;
            const logicalDirection = document.dir === 'rtl' ? -physicalDirection : physicalDirection;
            targetIndex += logicalDirection;
          } else if (Math.hypot(deltaX, deltaY) <= 8) {
            const bounds = this.carousel.getBoundingClientRect();
            const clickedStartHalf = event.clientX < bounds.left + bounds.width / 2;
            const logicalDirection = clickedStartHalf === (document.dir !== 'rtl') ? -1 : 1;
            targetIndex += logicalDirection;
          } else {
            return;
          }

          targetIndex = Math.max(0, Math.min(targetIndex, this.carousel.cells.length - 1));
          cancelAnimationFrame(this.navigationFrame);
          this.navigationFrame = requestAnimationFrame(() => this.carousel?.select(targetIndex));
        }

        scheduleNavigationStateUpdate() {
          cancelAnimationFrame(this.navigationStateFrame);
          this.navigationStateFrame = requestAnimationFrame(() => this.updateNavigationState());
        }

        getNavigationState() {
          const cells = this.carousel?.cells ?? [];

          if (cells.length === 0) {
            return { atStart: true, atEnd: true };
          }

          const carouselBounds = this.carousel.getBoundingClientRect();
          const firstBounds = cells[0].getBoundingClientRect();
          const lastBounds = cells[cells.length - 1].getBoundingClientRect();
          const tolerance = 2;
          const endInset =
            this.endClearance > 0 ? parseFloat(getComputedStyle(this.carousel).paddingInlineEnd) || 0 : 0;

          if (document.dir === 'rtl') {
            return {
              atStart: firstBounds.right <= carouselBounds.right + tolerance,
              atEnd: lastBounds.left >= carouselBounds.left + endInset - tolerance,
            };
          }

          return {
            atStart: firstBounds.left >= carouselBounds.left - tolerance,
            atEnd: lastBounds.right <= carouselBounds.right - endInset + tolerance,
          };
        }

        updateNavigationState() {
          if (!this.carousel) {
            return;
          }

          const { atStart, atEnd } = this.getNavigationState();
          const isScrollable = this.carousel.isScrollable;

          const atRightEdge = document.dir === 'rtl' ? atStart : atEnd;
          this.classList.toggle('cs-gallery--more-right', isScrollable && !atRightEdge);

          this.previousButtons.forEach((button) => (button.disabled = !isScrollable || atStart));
          this.nextButtons.forEach((button) => (button.disabled = !isScrollable || atEnd));
        }

        updateArrowCenter(slide = this.carousel?.selectedCell) {
          if (!slide || !this.sectionStack || !this.classList.contains('cs-gallery--center-arrows')) {
            return;
          }

          const desktopArrows = this.classList.contains('cs-gallery--center-arrows-desktop')
            ? this.querySelector('.cs-gallery__desktop-arrows')
            : null;
          const arrowWidth = desktopArrows?.getBoundingClientRect().width || 0;
          this.endClearance = arrowWidth > 0 ? Math.ceil(arrowWidth) + 16 : 0;
          this.style.setProperty('--cs-gallery-end-clearance', this.endClearance + 'px');

          const media = slide.querySelector('.cs-gallery-slide__media');

          if (!media) {
            return;
          }

          const stackBounds = this.sectionStack.getBoundingClientRect();
          const mediaBounds = media.getBoundingClientRect();
          const center = mediaBounds.top - stackBounds.top + mediaBounds.height / 2;

          const viewport = this.querySelector('.cs-gallery__viewport');
          if (viewport) {
            const viewportBounds = viewport.getBoundingClientRect();
            this.style.setProperty('--cs-gallery-media-top', mediaBounds.top - viewportBounds.top + 'px');
            this.style.setProperty('--cs-gallery-media-height', mediaBounds.height + 'px');
          }

          this.style.setProperty('--cs-gallery-arrow-center-y', `${center}px`);
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.setupFrame);
          cancelAnimationFrame(this.navigationFrame);
          cancelAnimationFrame(this.navigationStateFrame);
          this.resizeObserver?.disconnect();
          this.abortController?.abort();
        }

        isInteractive(target) {
          return target instanceof Element && target.closest('a, button, input, select, textarea, [role="button"]');
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-heat-map"] && !Shopify.designMode) return;
  try {
    
  /* Heat word, adapted from Bencho's HeatWord component.
     Copyright (c) 2026 Lorenzo Cabra

     Permission is hereby granted, free of charge, to any person obtaining a copy
     of this software and associated documentation files (the "Software"), to deal
     in the Software without restriction, including without limitation the rights
     to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     copies of the Software, and to permit persons to whom the Software is
     furnished to do so, subject to the following conditions:

     The above copyright notice and this permission notice shall be included in all
     copies or substantial portions of the Software.

     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     SOFTWARE.

     A field, then a palette: the shape is drawn twice, blurred, into a grey
     field. Each pixel's brightness is looked up in a 256-entry colour table.
     Nearby strokes overlap in the field and fuse where the heat pools.

     The blur is a shadow: ctx.filter is not in every Safari, shadowBlur is.
     Draw far off the canvas and throw the shadow back on, so only the blurred
     shadow lands. */

  const heatClamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const heatShapes = ['Dots', 'Asterisk', 'Word'];
  const heatPalettes = {
    Neon: [
      [0, [255, 150, 225]],
      [0.1, [255, 90, 190]],
      [0.2, [255, 50, 60]],
      [0.32, [255, 150, 40]],
      [0.42, [255, 228, 100]],
      [0.54, [120, 215, 255]],
      [0.68, [40, 120, 245]],
      [0.84, [12, 44, 150]],
      [1, [6, 18, 80]],
    ],
    Fire: [
      [0, [255, 238, 180]],
      [0.16, [255, 200, 80]],
      [0.34, [255, 130, 30]],
      [0.52, [228, 58, 28]],
      [0.72, [150, 18, 44]],
      [0.88, [74, 6, 42]],
      [1, [30, 2, 24]],
    ],
    Sea: [
      [0, [210, 255, 225]],
      [0.16, [110, 245, 175]],
      [0.34, [40, 215, 200]],
      [0.52, [40, 150, 235]],
      [0.72, [80, 70, 205]],
      [0.88, [60, 20, 130]],
      [1, [24, 8, 60]],
    ],
    Pop: [
      [0, [255, 225, 240]],
      [0.16, [255, 160, 210]],
      [0.34, [245, 110, 190]],
      [0.52, [180, 110, 255]],
      [0.72, [100, 150, 255]],
      [0.88, [40, 70, 190]],
      [1, [20, 24, 100]],
    ],
  };
  const heatTables = new Map();
  const heatGreyAlpha = new Uint8ClampedArray(256);
  for (let i = 0; i < 256; i++) heatGreyAlpha[i] = 255 * heatClamp((i - 70) / 45, 0, 1);

  function heatTable(name) {
    if (heatTables.has(name)) return heatTables.get(name);
    const stops = heatPalettes[name] || heatPalettes.Neon;
    const table = new Uint8ClampedArray(256 * 4);
    for (let i = 34; i < 256; i++) {
      const value = (i - 34) / 221;
      let stop = 0;
      while (stop < stops.length - 2 && value > stops[stop + 1][0]) stop++;
      const [start, from] = stops[stop];
      const [end, to] = stops[stop + 1];
      const blend = heatClamp((value - start) / (end - start), 0, 1);
      for (let channel = 0; channel < 3; channel++)
        table[i * 4 + channel] = from[channel] + (to[channel] - from[channel]) * blend;
      /* Below 34 it is transparent; the rim fades over the next 26 levels,
         so pink is a glow rather than a hard outline. */
      table[i * 4 + 3] = 255 * heatClamp((i - 34) / 26, 0, 1);
    }
    heatTables.set(name, table);
    return table;
  }

  class CSHeatMap extends HTMLElement {
    connectedCallback() {
      this.surface = this.querySelector('.cs-heat__surface');
      this.canvas = this.querySelector('canvas');
      if (!this.surface || !this.canvas) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.base = document.createElement('canvas');
      this.work = document.createElement('canvas');
      this.baseContext = this.base.getContext('2d');
      this.workContext = this.work.getContext('2d', { willReadFrequently: true });
      this.context = this.canvas.getContext('2d');
      if (!this.context || !this.baseContext || !this.workContext) {
        this.canvas.hidden = true;
        this.querySelector('.cs-heat__fallback').hidden = false;
        return;
      }
      this.word = this.dataset.word || 'BEND';
      this.shape = heatShapes.includes(this.dataset.shape) ? this.dataset.shape : 'Word';
      this.heat = heatClamp(Number(this.dataset.heat ?? 60), 0, 100);
      this.soft = heatClamp(Number(this.dataset.soft ?? 50), 0, 100);
      this.spread = 0.5 + heatClamp(Number(this.dataset.area ?? 50), 0, 100) / 100;
      this.duration = heatClamp(Number(this.dataset.sweepDuration ?? 4), 2, 12);
      this.auto = this.dataset.autoSweep !== 'false';
      this.palette = heatTable(this.dataset.palette || 'Neon');
      this.seed = Math.floor(Math.random() * 1000);
      this.state = { px: -0.4, py: 0.5, tx: -0.4, ty: 0.5, power: 0, want: 0, grow: 0 };
      this.pointerActive = false;
      this.elapsed = 0;
      this.idleDelay = 0;
      this.raf = 0;
      this.ready = false;
      this.visible = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.step = this.step.bind(this);
      this.surface.addEventListener(
        'pointerenter',
        (event) => {
          if (event.pointerType !== 'touch') this.aim(event, true);
        },
        { signal },
      );
      this.surface.addEventListener(
        'pointermove',
        (event) => {
          if (event.pointerType !== 'touch' || this.pointerActive) this.aim(event);
        },
        { signal },
      );
      this.surface.addEventListener('pointerdown', (event) => this.aim(event, true), { signal });
      this.surface.addEventListener('pointerleave', () => this.release(), { signal });
      this.surface.addEventListener('pointercancel', () => this.release(), { signal });
      /* Touch has no persistent hover: release on pointer-up even when the
         finger is still inside, so mobile always returns to the sweep. */
      document.addEventListener(
        'pointerup',
        (event) => {
          if (event.pointerType === 'touch') this.release();
        },
        { signal },
      );
      this.surface.addEventListener(
        'click',
        () => {
          if (!this.ready) return;
          this.shape = heatShapes[(heatShapes.indexOf(this.shape) + 1) % heatShapes.length];
          this.seed++;
          this.state.grow = this.motion.matches ? 1 : 0;
          this.field();
          this.updateLabel();
          this.run();
        },
        { signal },
      );
      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            this.pointerActive = false;
            this.stop();
          } else this.run();
        },
        { signal },
      );
      this.motion.addEventListener('change', () => this.run(), { signal });
      this.resizeObserver = new ResizeObserver(() => {
        if (this.ready) {
          this.build();
          this.run();
        }
      });
      this.resizeObserver.observe(this.surface);
      this.intersectionObserver = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        if (this.visible) this.run();
        else {
          this.pointerActive = false;
          this.stop();
        }
      });
      this.intersectionObserver.observe(this.surface);
      this.updateLabel();
      this.prepare(signal);
    }

    async prepare(signal) {
      /* The theme owns the face. Wait for that face rather than fetching one
         from Bencho or adding a font dependency. */
      this.font = getComputedStyle(this.surface);
      try {
        await document.fonts?.load(
          `${this.font.fontStyle} ${this.font.fontWeight} 100px ${this.font.fontFamily}`,
          this.word,
        );
      } catch {
        /* The theme's fallback face still draws a word. */
      }
      if (signal.aborted) return;
      this.ready = true;
      this.build();
      this.run();
    }

    disconnectedCallback() {
      this.ready = false;
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.stop();
    }

    updateLabel() {
      const name = this.shape === 'Word' ? this.word : this.shape;
      this.surface.setAttribute('aria-label', `${name}. ${this.dataset.label || 'Press to change shape.'}`);
    }

    aim(event, snap = false) {
      const rect = this.surface.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      this.pointerActive = true;
      this.state.tx = (event.clientX - rect.left) / rect.width;
      this.state.ty = (event.clientY - rect.top) / rect.height;
      if (snap) {
        this.state.px = this.state.tx;
        this.state.py = this.state.ty;
      }
      this.run();
    }

    release() {
      if (!this.pointerActive) return;
      this.pointerActive = false;
      this.elapsed = 0;
      /* Fade the real pointer before restarting off the left edge. */
      this.idleDelay = 0.45;
      this.run();
    }

    build() {
      const width = this.surface.getBoundingClientRect().width;
      if (!width) return;
      /* Match Bencho's 360:170 field; cap its raster at 2x to keep the
         per-pixel work bounded on dense mobile displays. */
      this.ratio = Math.min(2, (width / 360) * (window.devicePixelRatio || 1));
      for (const canvas of [this.base, this.work, this.canvas]) {
        canvas.width = Math.round(360 * this.ratio);
        canvas.height = Math.round(170 * this.ratio);
      }
      this.output = this.context.createImageData(this.canvas.width, this.canvas.height);
      this.field();
    }

    drawShape(context, offset) {
      const r = this.ratio,
        cx = this.base.width / 2,
        cy = this.base.height / 2;
      let randomState = this.seed * 9301 + 49297;
      const random = () => {
        randomState = (randomState * 9301 + 49297) % 233280;
        return randomState / 233280;
      };
      context.save();
      context.translate(-offset, 0);
      context.lineCap = 'round';
      context.lineJoin = 'round';
      if (this.shape === 'Dots') {
        /* A loose 7 by 3 grid. Nearest dots swell on a gaussian and fuse.
           Random calls stay in the same order so the layout never jumps. */
        const reach = 62 * r * this.spread;
        for (let row = 0; row < 3; row++) {
          for (let col = 0; col < 7; col++) {
            const x = cx + (col - 3) * 38 * r + (random() - 0.5) * 8 * r;
            const y = cy + (row - 1) * 38 * r + (random() - 0.5) * 8 * r;
            let radius = (9 + random() * 7) * r;
            const distance =
              ((x - this.state.px * this.base.width) ** 2 + (y - this.state.py * this.base.height) ** 2) /
              (reach * reach);
            radius *= 1 + 0.75 * this.state.power * Math.exp(-distance);
            context.beginPath();
            context.arc(x, y, radius, 0, Math.PI * 2);
            context.fill();
          }
        }
      } else {
        /* Fat bars crossing, every one of them through the centre. */
        context.lineWidth = 16 * r;
        const count = 3 + Math.floor(random() * 2),
          turn = random() * Math.PI;
        for (let i = 0; i < count; i++) {
          const angle = turn + (i / count) * Math.PI;
          const x = Math.cos(angle) * 66 * r,
            y = Math.sin(angle) * 66 * r;
          context.beginPath();
          context.moveTo(cx - x, cy - y);
          context.lineTo(cx + x, cy + y);
          context.stroke();
        }
      }
      context.restore();
    }

    field() {
      if (!this.base.width || !this.font) return;
      const g = this.baseContext,
        w = this.base.width,
        h = this.base.height,
        r = this.ratio;
      g.shadowColor = 'transparent';
      g.fillStyle = '#000';
      g.fillRect(0, 0, w, h);
      const offset = w * 3;
      g.shadowColor = '#fff';
      g.shadowBlur = (6 + (this.soft / 100) * 16) * r;
      g.shadowOffsetX = offset;
      g.fillStyle = '#fff';
      g.strokeStyle = '#fff';
      if (this.shape !== 'Word') {
        this.drawShape(g, offset);
        this.drawShape(g, offset);
        return;
      }
      let size = 150 * r;
      const face = `${this.font.fontStyle} ${this.font.fontWeight}`;
      g.font = `${face} ${size}px ${this.font.fontFamily}`;
      size = Math.min(size, (size * (w * 0.88)) / Math.max(1, g.measureText(this.word).width));
      g.font = `${face} ${size}px ${this.font.fontFamily}`;
      g.textAlign = 'center';
      g.textBaseline = 'middle';
      /* Twice over, so the thick of each stroke saturates. */
      g.fillText(this.word, w / 2 - offset, h / 2 + size * 0.04);
      g.fillText(this.word, w / 2 - offset, h / 2 + size * 0.04);
    }

    paint() {
      if (!this.output) return;
      const s = this.state,
        g = this.workContext,
        w = this.canvas.width,
        h = this.canvas.height;
      if (this.shape === 'Dots') this.field();
      g.globalCompositeOperation = 'source-over';
      g.globalAlpha = 1;
      g.fillStyle = '#000';
      g.fillRect(0, 0, w, h);
      g.globalAlpha = s.grow;
      g.drawImage(this.base, 0, 0);
      g.globalAlpha = 1;
      const cx = s.px * w,
        cy = s.py * h;
      if (s.power > 0.002) {
        /* Multiply cools the field under the pointer. Navy cores open into
           rings of blue, cyan, yellow and red; strokes thin as they melt. */
        const radius = (60 + (this.heat / 100) * 50) * this.ratio * this.spread;
        const amount = s.power * (0.35 + (this.heat / 100) * 0.55);
        const value = (k) => Math.round(255 * (1 - amount * k));
        const cool = g.createRadialGradient(cx, cy, 0, cx, cy, radius);
        cool.addColorStop(0, `rgb(${value(1)},${value(1)},${value(1)})`);
        cool.addColorStop(0.45, `rgb(${value(0.6)},${value(0.6)},${value(0.6)})`);
        cool.addColorStop(1, 'rgb(255,255,255)');
        g.globalCompositeOperation = 'multiply';
        g.fillStyle = cool;
        g.fillRect(0, 0, w, h);
      }
      const source = g.getImageData(0, 0, w, h).data,
        pixels = this.output.data;
      const radius2 = ((95 + (this.heat / 100) * 55) * this.ratio * this.spread) ** 2;
      /* A soft disc reveals the palette. Outside it the shape remains grey. */
      for (let y = 0, i = 0; y < h; y++) {
        const dy2 = (y - cy) ** 2;
        for (let x = 0; x < w; x++, i += 4) {
          const brightness = source[i],
            colour = brightness * 4;
          const distance = ((x - cx) ** 2 + dy2) / radius2;
          const t = Math.max(0, 1 - distance);
          const reveal = s.power * t * t * (3 - 2 * t),
            grey = 1 - reveal;
          pixels[i] = 150 * grey + this.palette[colour] * reveal;
          pixels[i + 1] = 150 * grey + this.palette[colour + 1] * reveal;
          pixels[i + 2] = 154 * grey + this.palette[colour + 2] * reveal;
          pixels[i + 3] = heatGreyAlpha[brightness] * grey + this.palette[colour + 3] * reveal;
        }
      }
      this.context.putImageData(this.output, 0, 0);
    }

    run() {
      if (!this.ready || !this.visible || document.hidden || this.raf) return;
      this.previous = performance.now();
      this.raf = requestAnimationFrame(this.step);
    }

    stop() {
      cancelAnimationFrame(this.raf);
      this.raf = 0;
    }

    step(time) {
      this.raf = 0;
      if (!this.ready || !this.visible || document.hidden) return;
      const dt = Math.min(0.05, (time - this.previous) / 1000),
        s = this.state;
      this.previous = time;
      const sweep = this.auto && !this.pointerActive && !this.motion.matches;
      if (this.pointerActive) {
        s.want = 1;
      } else if (this.motion.matches) {
        s.tx = s.ty = 0.5;
        s.want = this.auto ? 1 : 0;
      } else if (sweep && this.idleDelay <= 0) {
        /* One pass takes the configured duration, then pauses for one second.
           Start and end outside the canvas: the patch disappears before its
           invisible reset to the left, so it never sweeps right to left. */
        this.elapsed = (this.elapsed + dt) % (this.duration + 1);
        s.tx = -0.4 + 1.8 * Math.min(1, this.elapsed / this.duration);
        s.ty = 0.5;
        s.px = s.tx;
        s.py = s.ty;
        s.want = this.elapsed < this.duration ? 1 : 0;
      } else {
        this.idleDelay = Math.max(0, this.idleDelay - dt);
        s.want = 0;
      }
      if (this.motion.matches) {
        s.px = s.tx;
        s.py = s.ty;
        s.power = s.want;
        s.grow = 1;
      } else {
        const blend = 1 - Math.pow(0.002, dt);
        s.px += (s.tx - s.px) * blend;
        s.py += (s.ty - s.py) * blend;
        s.power += (s.want - s.power) * (1 - Math.pow(0.01, dt));
        s.grow = Math.min(1, s.grow + dt / 0.9);
      }
      const settled =
        s.grow >= 1 &&
        Math.abs(s.want - s.power) < 0.004 &&
        Math.abs(s.tx - s.px) < 0.001 &&
        Math.abs(s.ty - s.py) < 0.001;
      if (settled && s.want === 0) s.power = 0;
      this.paint();
      if (!this.motion.matches && (sweep || !settled)) this.raf = requestAnimationFrame(this.step);
    }
  }

  if (!customElements.get('cs-heat-map')) customElements.define('cs-heat-map', CSHeatMap);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-image-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.csImageShowcaseMotion) {
      window.csImageShowcaseMotion.refresh();
      return;
    }

    const selector = '.shopify-section--cs-image-showcase';
    const rootOf = (section) => section.querySelector(':scope > [data-cs-showcase-motion]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 699px)');
    const groups = [];
    const relays = new Set();
    const clamp = (value) => Math.min(1, Math.max(0, value));
    const stackRevealStart = 0.25;
    let frame = 0;
    let rebuildTimer = 0;
    let rebuilding = false;
    let relayObserver;
    let sizeObserver;

    function clear() {
      relayObserver?.disconnect();
      sizeObserver?.disconnect();
      for (const section of relays) {
        section.classList.remove('cs-showcase-motion-relay');
        section.removeAttribute('data-motion-pending');
      }
      relays.clear();
      for (const group of groups.splice(0)) {
        restoreHeading(group);
        for (const section of group.members) {
          for (const name of ['y', 'scale', 'opacity', 'brightness', 'layer', 'pointer']) {
            section.style.removeProperty('--cs-motion-' + name);
          }
        }
        // Read live children: the editor may already have replaced or removed a section.
        group.element.replaceWith(...group.stage.children);
      }
    }

    function restoreHeading(group) {
      if (!group.heading) return;
      // Restore only into a surviving section, never into an editor replacement.
      if (group.headingMarker.isConnected) group.headingMarker.replaceWith(group.heading);
      group.headingHost.remove();
    }

    function relay(members) {
      for (const section of members) {
        relays.add(section);
        section.classList.add('cs-showcase-motion-relay');
        const card = section.querySelector('.cs-image-showcase__frame');
        if (card.getBoundingClientRect().top >= window.innerHeight * 0.92) {
          section.setAttribute('data-motion-pending', '');
          relayObserver.observe(card);
        }
      }
    }

    function pin(members, mode, root) {
      if (members.slice(1).some((member) => member.querySelector('.cs-image-showcase__section-heading'))) {
        relay(members);
        return 'headings';
      }
      const firstSpacing = root.querySelector('.section-spacing');
      const lastSpacing = rootOf(members.at(-1)).querySelector('.section-spacing');
      const topPadding = parseFloat(getComputedStyle(firstSpacing).paddingTop) || 0;
      const bottomPadding = parseFloat(getComputedStyle(lastSpacing).paddingBottom) || 0;
      const element = document.createElement('div');
      const stage = document.createElement('div');
      element.className = 'cs-showcase-motion-group';
      // The scroll runway must retain the section background when cards move away.
      element.style.backgroundColor = getComputedStyle(root).backgroundColor;
      element.style.backgroundImage = getComputedStyle(root).backgroundImage;
      stage.className = 'cs-showcase-motion-stage';
      element.dataset.motionMode = mode;
      element.style.setProperty('--cs-motion-offset', (Number(root.dataset.motionOffset) || 0) + 'px');
      element.style.paddingBlock = topPadding + 'px ' + bottomPadding + 'px';
      members[0].before(element);
      element.append(stage);
      stage.append(...members);

      const heading = members[0].querySelector('.cs-image-showcase__section-heading');
      const headingState = {};
      if (heading) {
        const headingMarker = document.createComment('showcase heading');
        const headingHost = document.createElement('div');
        headingHost.className = root.className + ' cs-showcase-motion-heading';
        const headingContainer = document.createElement('div');
        headingContainer.className = heading.parentElement.className;
        const styles = getComputedStyle(members[0]);
        for (const name of styles) {
          if (name.startsWith('--cs-showcase-')) headingHost.style.setProperty(name, styles.getPropertyValue(name));
        }
        heading.before(headingMarker);
        headingContainer.append(heading);
        headingHost.append(headingContainer);
        stage.prepend(headingHost);
        Object.assign(headingState, { heading, headingMarker, headingHost });
      }
      const headingHeight = headingState.headingHost?.getBoundingClientRect().height || 0;
      const containers = members.map((member) => member.querySelector('.cs-image-showcase__frame'));
      const height = Math.ceil(Math.max(...containers.map((container) => container.getBoundingClientRect().height)));
      const top = parseFloat(getComputedStyle(stage).top) || 0;
      // Tall content keeps its natural reading flow instead of being clipped in a pinned stage.
      if (height <= 0 || headingHeight + height > window.innerHeight - top - 24) {
        restoreHeading(headingState);
        element.replaceWith(...stage.children);
        relay(members);
        return 'tall';
      }

      const speed = Math.min(150, Math.max(25, Number(root.dataset.motionSpeed) || 100)) / 100;
      // Add a full-card reading phase without accelerating the following card's entry.
      const entryShare = mode === 'stack' ? 1 - stackRevealStart : 1;
      const travel = ((members.length - 1) * Math.max(height, window.innerHeight * 0.65)) / (speed * entryShare);
      element.style.setProperty('--cs-motion-stage-height', height + 'px');
      element.style.height = headingHeight + height + travel + topPadding + bottomPadding + 'px';
      const group = { element, stage, members, mode, travel, topPadding, height, headingHeight, ...headingState };
      groups.push(group);
      for (const container of containers) sizeObserver.observe(container);
      if (headingState.headingHost) sizeObserver.observe(headingState.headingHost);
      return mode;
    }

    function render() {
      frame = 0;
      for (const group of groups) {
        const top = parseFloat(getComputedStyle(group.stage).top) || 0;
        const progress = clamp((top - group.element.getBoundingClientRect().top - group.topPadding) / group.travel);
        const position = progress * (group.members.length - 1);
        const current = Math.min(Math.floor(position), group.members.length - 1);
        const blend = position - current;
        const stacking = group.mode === 'stack';
        const entry = stacking ? clamp((blend - stackRevealStart) / (1 - stackRevealStart)) : blend;
        group.members.forEach((section, index) => {
          const active = index === current;
          const next = index === current + 1;
          const opacity = active ? (stacking ? 1 : 1 - blend) : next ? (stacking ? (entry > 0 ? 1 : 0) : blend) : 0;
          const y = stacking && next ? (1 - entry) * group.height : 0;
          section.style.setProperty('--cs-motion-opacity', opacity);
          section.style.setProperty('--cs-motion-y', y + 'px');
          section.style.setProperty('--cs-motion-scale', stacking && active ? 1 - blend * 0.1 : 1);
          section.style.setProperty('--cs-motion-brightness', stacking && active ? 1 - blend * 0.16 : 1);
          section.style.setProperty('--cs-motion-layer', index);
          section.style.setProperty(
            '--cs-motion-pointer',
            (active && entry < 0.5) || (next && entry >= 0.5) ? 'auto' : 'none',
          );
        });
      }
    }

    function requestRender() {
      if (!frame && groups.length) frame = requestAnimationFrame(render);
    }

    function rebuild() {
      if (rebuilding) return;
      rebuilding = true;
      try {
        clear();
        relayObserver = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              entry.target.closest(selector)?.removeAttribute('data-motion-pending');
              relayObserver.unobserve(entry.target);
            }
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0 },
        );
        const sizes = new WeakMap();
        sizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const dimensions = entry.target.offsetWidth + ':' + entry.target.offsetHeight;
            const previous = sizes.get(entry.target);
            sizes.set(entry.target, dimensions);
            if (previous && previous !== dimensions) refresh();
          }
        });

        const consumed = new Set();
        for (const section of document.querySelectorAll(selector)) {
          if (consumed.has(section)) continue;
          const root = rootOf(section);
          if (!root || !section.getClientRects().length) continue;
          const members = [];
          let next = section;
          while (next?.matches(selector) && rootOf(next) && next.getClientRects().length) {
            members.push(next);
            consumed.add(next);
            next = next.nextElementSibling;
          }
          if (!['relay', 'stack', 'scenes'].includes(root.dataset.csShowcaseMotion)) {
            continue;
          }
          if (members.length < 2) continue;
          if (reduced.matches) {
            continue;
          }
          // The first section owns the entire consecutive run, including None.
          let mode = mobile.matches ? root.dataset.motionMobile : root.dataset.csShowcaseMotion;
          if (mode === 'none') {
            continue;
          }
          if (members.some((member) => member.contains(document.activeElement))) {
            mode = 'relay';
          }
          if (mode === 'relay') relay(members);
          else pin(members, mode, root);
        }
        render();
      } finally {
        rebuilding = false;
      }
    }

    function refresh() {
      clearTimeout(rebuildTimer);
      rebuildTimer = setTimeout(rebuild, 120);
    }

    window.csImageShowcaseMotion = { refresh };
    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('pageshow', refresh);
    reduced.addEventListener('change', refresh);
    mobile.addEventListener('change', refresh);
    document.addEventListener('focusin', (event) => {
      const section = event.target.closest?.(selector);
      if (!section) return;
      section.removeAttribute('data-motion-pending');
      if (section.closest('.cs-showcase-motion-group')) rebuild();
    });
    document.addEventListener('shopify:section:select', (event) => {
      rebuild();
      if (event.target.matches(selector))
        requestAnimationFrame(() => event.target.scrollIntoView({ block: 'nearest' }));
    });
    document.addEventListener('shopify:section:deselect', refresh);
    document.addEventListener('shopify:section:unload', () => {
      clear();
      refresh();
    });
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:reorder', refresh);
    document.fonts?.ready.then(refresh);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
    else refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-kickstarter-trust"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-trust-content')) {
    class CsTrustContent extends HTMLElement {
      connectedCallback() {
        this.observer ??= new MutationObserver(() => this.highlightBrackets());
        this.highlightBrackets();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      highlightBrackets() {
        this.observer.disconnect();

        const groups = [];
        const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
        let currentGroup = null;

        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (node.parentElement.closest('.cs-trust__emphasis')) {
            currentGroup = null;
            continue;
          }

          const container = node.parentElement.closest('p, li') ?? this;
          if (currentGroup?.container !== container) {
            currentGroup = { container, nodes: [] };
            groups.push(currentGroup);
          }
          currentGroup.nodes.push(node);
        }

        for (const { nodes } of groups) {
          const text = nodes.map((node) => node.data).join('');
          const matches = Array.from(text.matchAll(/\[([^\[\]]+)\]/g)).reverse();

          const locate = (offset) => {
            for (const node of nodes) {
              if (offset < node.length) return { node, offset };
              offset -= node.length;
            }
          };

          for (const match of matches) {
            const start = locate(match.index);
            const end = locate(match.index + match[0].length - 1);
            const range = document.createRange();
            range.setStart(start.node, start.offset);
            range.setEnd(end.node, end.offset + 1);

            const content = range.extractContents();
            const contentWalker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
            const contentNodes = [];
            while (contentWalker.nextNode()) contentNodes.push(contentWalker.currentNode);
            contentNodes[0].data = contentNodes[0].data.slice(1);
            contentNodes[contentNodes.length - 1].data = contentNodes[contentNodes.length - 1].data.slice(0, -1);

            const emphasis = document.createElement('span');
            emphasis.className = 'cs-trust__emphasis';
            emphasis.append(content);
            range.insertNode(emphasis);
          }
        }

        this.observer.observe(this, { childList: true, characterData: true, subtree: true });
      }
    }

    customElements.define('cs-trust-content', CsTrustContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-new-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-new-slideshow-navigation')) {
    customElements.define(
      'cs-new-slideshow-navigation',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();

          this.addEventListener(
            'click',
            (event) => {
              if (event.target.closest('carousel-prev-button, carousel-next-button')) {
                this.stopAutoplay();
              }
            },
            { capture: true, signal: this.abortController.signal },
          );

          this.setupFrame = requestAnimationFrame(() => this.setupCarousel());
        }

        setupCarousel() {
          this.carousel = this.querySelector('slideshow-carousel');
          this.replayButton = this.querySelector('.cs-new-slideshow__replay');
          this.mediaObserver = new ResizeObserver(() => this.updateMediaControls());
          this.mediaObserver.observe(this);
          this.querySelectorAll('.cs-new-slideshow__slide-layout, .content-box__background-media').forEach(
            (element) => {
              this.mediaObserver.observe(element);
            },
          );

          this.querySelectorAll('video').forEach((video) => {
            video.loop = this.dataset.loopVideos === 'true';

            ['ended', 'play', 'seeking', 'emptied'].forEach((eventName) => {
              video.addEventListener(eventName, () => this.updateReplayButton(), {
                signal: this.abortController.signal,
              });
            });
          });

          this.replayButton?.addEventListener('click', () => this.replayVideo(), {
            signal: this.abortController.signal,
          });

          this.updateArrowColors(this.carousel?.querySelector('.slideshow__slide.is-selected'));

          this.carousel?.addEventListener('carousel:select', (event) => this.updateArrowColors(event.detail.cell), {
            signal: this.abortController.signal,
          });

          this.carousel?.addEventListener(
            'pointerdown',
            (event) => {
              if (event.pointerType !== 'mouse' || event.button !== 0 || this.isInteractive(event.target)) {
                this.pointerStart = null;
                return;
              }

              this.pointerStart = { x: event.clientX, y: event.clientY };
            },
            { signal: this.abortController.signal },
          );

          this.carousel?.addEventListener(
            'pointerup',
            (event) => {
              if (!this.pointerStart || event.pointerType !== 'mouse' || this.isInteractive(event.target)) {
                this.pointerStart = null;
                return;
              }

              const distance = Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y);
              this.pointerStart = null;

              if (distance > 8) {
                return;
              }

              const bounds = this.carousel.getBoundingClientRect();
              this.stopAutoplay();

              if (event.clientX < bounds.left + bounds.width / 2) {
                this.carousel.previous();
              } else {
                this.carousel.next();
              }
            },
            { signal: this.abortController.signal },
          );
        }

        updateArrowColors(slide) {
          if (!slide || !this.carousel) {
            return;
          }

          const arrowColor = slide.style.getPropertyValue('--cybersight-slide-arrow-color');

          this.carousel.style.setProperty('--slideshow-controls-color', arrowColor);
          this.carousel.style.setProperty('--cs-new-slideshow-arrow-color', arrowColor);
          this.style.setProperty('--cybersight-replay-color', arrowColor ? `rgb(${arrowColor})` : '#fff');

          this.updateReplayButton(slide);
          this.updateMediaControls(slide);
        }

        updateMediaControls(slide = this.carousel?.selectedCell) {
          const media = slide?.querySelector('.content-box__background-media');
          if (!media) return;

          // Use layout offsets so slide transition transforms do not move the controls.
          let mediaTop = 0;
          let element = media;
          while (element && element !== this) {
            mediaTop += element.offsetTop;
            element = element.offsetParent;
          }
          if (element !== this) return;
          const bottom = Math.max(0, this.offsetHeight - mediaTop - media.offsetHeight);
          this.style.setProperty('--cs-new-slideshow-media-bottom', bottom + 'px');
        }

        updateReplayButton(slide = this.carousel?.selectedCell) {
          if (!this.replayButton) {
            return;
          }

          const video = slide?.querySelector('video');
          this.replayButton.hidden = this.dataset.loopVideos === 'true' || !video || video.loop || !video.ended;
        }

        replayVideo() {
          const slide = this.carousel?.selectedCell;
          const video = Array.from(slide?.querySelectorAll('video') || []).find((item) => item.offsetParent !== null);

          if (!video) {
            return;
          }

          this.stopAutoplay();
          this.replayButton.hidden = true;
          video.currentTime = 0;
          video.play().catch(() => {
            video.controls = true;
          });
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.setupFrame);
          this.mediaObserver?.disconnect();
          this.abortController?.abort();
        }

        isInteractive(target) {
          return target.closest('a, button, input, select, textarea, [role="button"]');
        }

        stopAutoplay() {
          const carousel = this.querySelector('slideshow-carousel');

          carousel?.player?.stop();
          carousel?.removeAttribute('autoplay');
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-reservation-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-reservation-floating')) {
    customElements.define(
      'cs-reservation-floating',
      class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section');
          this.offer = this.section?.querySelector('.cs-reservation-offer');
          if (!this.offer) return;
          this.editorSelected = false;
          this.abortController = new AbortController();
          const signal = this.abortController.signal;
          this.update = () => {
            this.frame = null;
            const passed = this.offer.getBoundingClientRect().bottom <= 0;
            const visible = this.editorSelected || passed;
            this.toggleAttribute('data-visible', visible);
            this.setAttribute('aria-hidden', String(!visible));
            this.inert = !visible;
          };
          this.scheduleUpdate = () => {
            if (this.frame == null) this.frame = requestAnimationFrame(this.update);
          };
          window.addEventListener('scroll', this.scheduleUpdate, { passive: true, signal });
          window.addEventListener('resize', this.scheduleUpdate, { passive: true, signal });
          this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
          this.resizeObserver.observe(this.offer);
          if (window.Shopify?.designMode) {
            document.addEventListener(
              'shopify:block:select',
              (event) => {
                this.editorSelected = event.detail.blockId === this.dataset.blockId;
                this.update();
              },
              { signal },
            );
            document.addEventListener(
              'shopify:block:deselect',
              (event) => {
                if (event.detail.blockId === this.dataset.blockId) {
                  this.editorSelected = false;
                  this.update();
                }
              },
              { signal },
            );
          }
          this.update();
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
          if (this.frame != null) cancelAnimationFrame(this.frame);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cybersight-slideshow-navigation')) {
    customElements.define(
      'cybersight-slideshow-navigation',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();

          this.addEventListener(
            'click',
            (event) => {
              if (event.target.closest('carousel-prev-button, carousel-next-button')) {
                this.stopAutoplay();
              }
            },
            { capture: true, signal: this.abortController.signal },
          );

          this.setupFrame = requestAnimationFrame(() => this.setupCarousel());
        }

        setupCarousel() {
          this.carousel = this.querySelector('slideshow-carousel');
          this.replayButton = this.querySelector('.cybersight-slideshow__replay');
          this.pendingVideos = new WeakSet();
          this.videoInView = false;

          this.querySelectorAll('video').forEach((video) => {
            video.loop = this.dataset.loopVideos === 'true';
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            if (video.loop) {
              video.controls = false;
            }

            const media = video.closest('video-media');
            const poster = Array.from(media.querySelectorAll(':scope > img')).find(
              (image) => getComputedStyle(image).display !== 'none',
            );

            if (poster) {
              video.poster = poster.currentSrc || poster.src;
            }

            const markVideoReady = () => {
              media.setAttribute('data-cs-video-ready', '');
              media.removeAttribute('suspended');
              video.controls = false;
            };

            video.addEventListener('playing', markVideoReady, { signal: this.abortController.signal });

            if (!video.paused && video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
              markVideoReady();
            }

            video.addEventListener('canplay', () => this.resumeVisibleVideo(), {
              signal: this.abortController.signal,
            });

            ['emptied', 'error'].forEach((eventName) => {
              video.addEventListener(eventName, () => media.removeAttribute('data-cs-video-ready'), {
                signal: this.abortController.signal,
              });
            });

            ['waiting', 'pause'].forEach((eventName) => {
              video.addEventListener(
                eventName,
                () => {
                  if (video.loop) {
                    media.removeAttribute('data-cs-video-ready');
                  }
                },
                { signal: this.abortController.signal },
              );
            });

            ['ended', 'play', 'seeking', 'emptied'].forEach((eventName) => {
              video.addEventListener(eventName, () => this.updateReplayButton(), {
                signal: this.abortController.signal,
              });
            });
          });

          // Snow enables controls after a blocked play attempt; looped backgrounds must keep them hidden.
          if (this.dataset.loopVideos === 'true') {
            this.videoControlsObserver = new MutationObserver((records) => {
              records.forEach(({ target }) => {
                if (target.tagName === 'VIDEO' && target.controls) {
                  target.controls = false;
                }
              });
            });
            this.videoControlsObserver.observe(this, {
              subtree: true,
              attributes: true,
              attributeFilter: ['controls'],
            });
          }

          this.replayButton?.addEventListener('click', () => this.replayVideo(), {
            signal: this.abortController.signal,
          });

          this.updateArrowColors(this.carousel?.querySelector('.slideshow__slide.is-selected'));

          this.carousel?.addEventListener('carousel:select', (event) => this.updateArrowColors(event.detail.cell), {
            signal: this.abortController.signal,
          });

          this.carousel?.addEventListener('carousel:settle', () => this.resumeVisibleVideo(), {
            signal: this.abortController.signal,
          });

          this.videoObserver = new IntersectionObserver(([entry]) => {
            this.videoInView = entry.isIntersecting;
            if (this.videoInView) {
              this.resumeVisibleVideo();
            }
          });
          this.videoObserver.observe(this);

          document.addEventListener('visibilitychange', () => this.resumeVisibleVideo(), {
            signal: this.abortController.signal,
          });
          window.addEventListener('pageshow', () => this.resumeVisibleVideo(), {
            signal: this.abortController.signal,
          });

          this.addEventListener(
            'click',
            (event) => {
              // Native controls handle their own clicks; other background taps can retry synchronously.
              if (!this.isInteractive(event.target)) {
                this.resumeVisibleVideo(true);
              }
            },
            { signal: this.abortController.signal },
          );

          this.carousel?.addEventListener(
            'pointerdown',
            (event) => {
              if (event.pointerType !== 'mouse' || event.button !== 0 || this.isInteractive(event.target)) {
                this.pointerStart = null;
                return;
              }

              this.pointerStart = { x: event.clientX, y: event.clientY };
            },
            { signal: this.abortController.signal },
          );

          this.carousel?.addEventListener(
            'pointerup',
            (event) => {
              if (!this.pointerStart || event.pointerType !== 'mouse' || this.isInteractive(event.target)) {
                this.pointerStart = null;
                return;
              }

              const distance = Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y);
              this.pointerStart = null;

              if (distance > 8) {
                return;
              }

              if (
                this.dataset.loopVideos !== 'true' &&
                this.carousel.querySelector('.slideshow__slide.is-selected video-media[suspended]')
              ) {
                return;
              }

              const bounds = this.carousel.getBoundingClientRect();
              this.stopAutoplay();

              if (event.clientX < bounds.left + bounds.width / 2) {
                this.carousel.previous();
              } else {
                this.carousel.next();
              }
            },
            { signal: this.abortController.signal },
          );
        }

        resumeVisibleVideo(userInitiated = false) {
          if (!this.isConnected || !this.videoInView || document.visibilityState !== 'visible') {
            return;
          }

          const slide = this.carousel?.querySelector('.slideshow__slide.is-selected');
          const video = Array.from(slide?.querySelectorAll('video') || []).find((item) => item.offsetParent !== null);

          // Preserve a finished, non-looping video's replay button and never restart inactive slides.
          if (!video || !video.paused || (video.ended && !video.loop) || video.offsetParent === null) {
            return;
          }

          if (this.pendingVideos.has(video) && !userInitiated) {
            return;
          }

          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          this.pendingVideos.add(video);

          // Call the media element directly so a tap retains Safari's user activation.
          video
            .play()
            .catch((error) => {
              if (error.name === 'NotAllowedError' && video.paused && this.isConnected) {
                const media = video.closest('video-media');
                media.setAttribute('suspended', '');
                video.controls = !video.loop;
                if (video.loop) {
                  media.removeAttribute('data-cs-video-ready');
                }
              }
            })
            .finally(() => this.pendingVideos.delete(video));
        }

        updateArrowColors(slide) {
          if (!slide || !this.carousel) {
            return;
          }

          const arrowColor = slide.style.getPropertyValue('--cybersight-slide-arrow-color');

          this.carousel.style.setProperty('--slideshow-controls-color', arrowColor);
          this.carousel.style.setProperty('--cybersight-slideshow-arrow-color', arrowColor);
          this.style.setProperty('--cybersight-replay-color', arrowColor ? `rgb(${arrowColor})` : '#fff');

          this.updateReplayButton(slide);
        }

        updateReplayButton(slide = this.carousel?.selectedCell) {
          if (!this.replayButton) {
            return;
          }

          const video = slide?.querySelector('video');
          this.replayButton.hidden = this.dataset.loopVideos === 'true' || !video || video.loop || !video.ended;
        }

        replayVideo() {
          const slide = this.carousel?.selectedCell;
          const video = Array.from(slide?.querySelectorAll('video') || []).find((item) => item.offsetParent !== null);

          if (!video) {
            return;
          }

          this.stopAutoplay();
          this.replayButton.hidden = true;
          video.currentTime = 0;
          video.play().catch(() => {
            video.controls = true;
          });
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.setupFrame);
          this.videoObserver?.disconnect();
          this.videoControlsObserver?.disconnect();
          this.abortController?.abort();
        }

        isInteractive(target) {
          return target.closest('a, button, input, select, textarea, [role="button"], video[controls]');
        }

        stopAutoplay() {
          const carousel = this.querySelector('slideshow-carousel');

          carousel?.player?.stop();
          carousel?.removeAttribute('autoplay');
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-split-showcase"] && !Shopify.designMode) return;
  try {
    
  if (window.Shopify?.designMode && !customElements.get('cs-split-image-guide')) {
    customElements.define(
      'cs-split-image-guide',
      class extends HTMLElement {
        connectedCallback() {
          const frame = this.parentElement;
          const output = this.querySelector('[data-frame-size]');
          this.observer = new ResizeObserver(() => {
            const { width, height } = frame.getBoundingClientRect();
            output.textContent =
              height > 0
                ? `Frame: ${Math.round(width)} × ${Math.round(height)}px · ${(width / height).toFixed(2)}:1`
                : 'Image frame';
          });
          this.observer.observe(frame);
        }
        disconnectedCallback() {
          this.observer?.disconnect();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-tab-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-tab-media')) {
    class CsTabMedia extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.cs-tabs__item'));
        this.panels = Array.from(this.querySelectorAll('.cs-tabs__image-panel'));
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.addEventListener(
          'click',
          (event) => {
            const summary = event.target.closest('.cs-tabs__tab');
            if (!summary || !this.contains(summary)) return;
            event.preventDefault();
            this.selectItem(summary.closest('.cs-tabs__item'));
          },
          options,
        );

        this.addEventListener(
          'keydown',
          (event) => {
            const summary = event.target.closest('.cs-tabs__tab');
            if (!summary) return;
            const index = this.items.indexOf(summary.closest('.cs-tabs__item'));
            let nextIndex;
            if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.items.length;
            else if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.items.length) % this.items.length;
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = this.items.length - 1;
            else return;
            event.preventDefault();
            this.selectItem(this.items[nextIndex]);
            this.items[nextIndex].querySelector('summary').focus();
          },
          options,
        );

        this.addEventListener(
          'shopify:block:select',
          (event) => {
            const item = this.items.find((entry) => entry.dataset.blockId === event.detail.blockId);
            if (item) this.selectItem(item);
          },
          options,
        );

        const selectedItem = this.items.find((item) => item.open) || this.items[0];
        if (selectedItem) this.selectItem(selectedItem);
      }

      disconnectedCallback() {
        this.controller.abort();
      }

      selectItem(selectedItem) {
        this.items.forEach((item) => {
          const selected = item === selectedItem;
          item.open = selected;
          item.querySelector('summary').setAttribute('aria-expanded', String(selected));
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.blockId !== selectedItem.dataset.blockId;
        });
      }
    }

    customElements.define('cs-tab-media', CsTabMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cybersight-tabbed-multi-column"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cybersight-tabbed-multi-column')) {
    customElements.define(
      'cybersight-tabbed-multi-column',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

          for (const tab of this.tabs) {
            tab.addEventListener('click', () => this.selectTab(tab), { signal: this.abortController.signal });
            tab.addEventListener('keydown', (event) => this.onTabKeydown(event), {
              signal: this.abortController.signal,
            });
          }

          this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), {
            signal: this.abortController.signal,
          });
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        selectTab(tab, { focus = false, resetCarousel = true } = {}) {
          if (!tab) {
            return;
          }

          const panelId = tab.getAttribute('aria-controls');

          for (const candidate of this.tabs) {
            const isSelected = candidate === tab;
            candidate.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            candidate.tabIndex = isSelected ? 0 : -1;
          }

          for (const panel of this.panels) {
            panel.hidden = panel.id !== panelId;
          }

          if (focus) {
            tab.focus();
          }

          this.scrollTabIntoView(tab);

          const panel = this.querySelector(`#${CSS.escape(panelId)}`);
          const track = panel?.querySelector('.cs-tabbed-multi-column__track');

          if (resetCarousel && typeof track?.select === 'function') {
            track.select(0, { instant: true });
          } else if (resetCarousel) {
            track?.scrollTo({ left: 0, behavior: 'auto' });
          }
        }

        scrollTabIntoView(tab) {
          const tablist = tab.closest('[role="tablist"]');

          if (!tablist) {
            return;
          }

          const tablistRect = tablist.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          let offset = 0;

          if (tabRect.left < tablistRect.left) {
            offset = tabRect.left - tablistRect.left - 8;
          } else if (tabRect.right > tablistRect.right) {
            offset = tabRect.right - tablistRect.right + 8;
          }

          if (offset !== 0) {
            tablist.scrollBy({
              left: offset,
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            });
          }
        }

        onTabKeydown(event) {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
            return;
          }

          event.preventDefault();

          const currentIndex = this.tabs.indexOf(event.currentTarget);
          const logicalDirection = document.dir === 'rtl' ? -1 : 1;
          let nextIndex = currentIndex;

          if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = this.tabs.length - 1;
          } else if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + logicalDirection + this.tabs.length) % this.tabs.length;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - logicalDirection + this.tabs.length) % this.tabs.length;
          }

          this.selectTab(this.tabs[nextIndex], { focus: true });
        }

        onBlockSelect(event) {
          const item = event.target.closest('[data-column]');

          if (!item || !this.contains(item)) {
            return;
          }

          const tab = this.querySelector(`[role="tab"][data-tab-index="${item.dataset.column}"]`);
          this.selectTab(tab, { resetCarousel: false });

          requestAnimationFrame(() => {
            const track = item.closest('.cs-tabbed-multi-column__track');
            const itemIndex = Array.isArray(track?.cells) ? track.cells.indexOf(item) : -1;

            if (itemIndex >= 0 && typeof track.select === 'function') {
              track.select(itemIndex, { instant: event.detail?.load ?? false });
            }
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
